import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export interface ICancelInvoiceParams {
	Notes: string;
	InvoiceId: number;
	Adjustments: Array<unknown>;
	SFCError: boolean;
	PaymentNotes: string;
}

export const { thunk: cancelInvoice, slice: cancelInvoiceSlice } = getThunkAndSlice<
	ICancelInvoiceParams,
	typeof initialState
>({
	initialState,
	path: "/api/Sales/CancelInvoice",
	method: "post",
});
